import React, { useContext } from "react";
import { AppContext } from "../App";
import swal from "sweetalert";
function GameOver() {
  const { currAttempt, gameOver, correctWord } = useContext(AppContext);

  const handleWonAlert = () => {
    swal("Hurray!", "You Correctly Guessed the Wordle.", "success");
  };

  const handleLoseAlert = () => {
    swal("Oops!", "You Failed to Guess the Word.", "error");
  };

  return (
    <div className="gameOver">
      <h3>{gameOver.guessedWord ? handleWonAlert() : handleLoseAlert()}</h3>
      <h1>Correct Word: {correctWord.toUpperCase()}</h1>
      {gameOver.guessedWord && (
        <h3>You Guessed in {currAttempt.attempt} Attempts</h3>
      )}
    </div>
  );
}

export default GameOver;
